import React from 'react'

function Footer() {

    const year = new Date().getFullYear();

    return (
        <footer className="page-footer font-small pt-4 bg-primary">
            <div className="container py-5">
                <div className="row">
                    <div className="col-4 text-center">
                        <a href="https://play.google.com/store/apps/details?id=com.progitek.footgrail&hl=no">
                            <i className="fab fa-android fa-2x"></i>
                        </a>
                    </div>
                    <div className="col-4 text-center">
                        <a href="https://apps.apple.com/us/app/id1526845196">
                            <i className="fab fa-app-store-ios fa-2x"></i>
                        </a>
                    </div>
                    <div className="col-4 text-center">
                        <a href="https://progitek.no/privat/bp/">
                            <i className="fas fa-wifi fa-2x"></i>
                        </a>
                    </div>
                </div>
            </div>
            
            <div className="footer-copyright text-center py-3">
                <div className="container-fluid">© {year} Copyright:<a href="https://www.progitek.no" alt=""> Ole Petter Kyrkjebø Hjønnevåg </a></div>
            </div>

        </footer>
    )
}
export default Footer